import { createQueryKeyStore } from "@lukemorales/query-key-factory";

import type { Category } from "@/shared/domains";
import { getStateOptions } from "./location";

export const queriesStore = createQueryKeyStore({
  location: {
    options: {
      queryKey: null,
      contextQueries: {
        state: (categorySlug?: Category["slug"]) => ({
          queryKey: [categorySlug],
          queryFn: () => getStateOptions(categorySlug),
        }),
      },
    },
  },
});
